import { UserModule } from '@core/modules/user/user.module'
import { ASM_DIALOGS_MAP, DialogService } from '@core/services/dialog'
import { formatDate } from '@core/utils/time'
import { TTheme, useCustomTheme } from '@/core/theme'
import Show from '@components/helpers/Show'
import Icon from '@/ui/components/icons/base-icon'
import ContentItem from '@components/page-content/content-item'
import Typography from '@/ui/components/typography'
import { Card } from '@routes/settings/routes/user/settings.user.route.styles'
import {
    CardHeader,
    DetailsColumn,
    DetailsGrid,
    EditButton,
} from './UserDetails.styles'
import EditIcon from '@assets/images/edit-icon.svg?react'

const UserDetails = () => {
    const { currentUser } = UserModule.useStore()
    const theme = useCustomTheme() as TTheme

    const handleEditUser = async () => {
        await DialogService.showDialog(ASM_DIALOGS_MAP.EDIT_USER)
    }

    return (
        <Card>
            <CardHeader>
                <Typography
                    component="p"
                    variant="m-regular"
                    color={theme.colors.greys[800]}
                >
                    User details
                </Typography>
                <EditButton data-testid="edit-user-button">
                    <Icon onClick={handleEditUser}>
                        <EditIcon />
                    </Icon>
                </EditButton>
            </CardHeader>

            <DetailsGrid>
                <DetailsColumn>
                    <ContentItem label="User name">
                        <Typography
                            variant="s-regular"
                            color={theme.colors.greys[800]}
                        >
                            {currentUser?.first_name} {currentUser?.last_name}
                        </Typography>
                    </ContentItem>

                    <ContentItem label="User email">
                        <Typography
                            variant="s-regular"
                            color={theme.colors.greys[800]}
                        >
                            {currentUser?.email?.value}
                        </Typography>
                    </ContentItem>
                </DetailsColumn>

                <DetailsColumn>
                    <ContentItem label="User title">
                        <Typography
                            variant="s-regular"
                            color={theme.colors.greys[800]}
                        >
                            {currentUser?.job_title}
                        </Typography>
                    </ContentItem>

                    <Show when={!!currentUser?.created_at}>
                        <ContentItem label="Date signed up">
                            <Typography
                                variant="s-regular"
                                color={theme.colors.greys[800]}
                            >
                                {currentUser?.created_at &&
                                    formatDate(currentUser?.created_at)}
                            </Typography>
                        </ContentItem>
                    </Show>
                </DetailsColumn>
            </DetailsGrid>
        </Card>
    )
}

export default UserDetails
